import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import {calculateAsOfDate} from "../../../../helpers/utils/OrderDetailUtils";

interface Props {
    row: any;
    setJurisdictionIdIndex: any;
    p: any;
    setAutoCalculate: any;
    name: any;
    editable: any;
    setIsSavedResult: any;
    setUpdateTotalTaxValue?: any;
    setIsAddNewSummaryRow?: any;
    setTaxYear?: any;
}

export const JurisdictionRowFormatting: React.FC<Props> = ({
                                                               row,
                                                               setJurisdictionIdIndex,
                                                               p,
                                                               setAutoCalculate,
                                                               name,
                                                               editable,
                                                               setIsSavedResult,
                                                               setUpdateTotalTaxValue = null,
                                                               setIsAddNewSummaryRow = null,
                                                               setTaxYear = null
                                                           }) => {
    const [localValue, setLocalValue] = useState(row[name] ?? '');

    useEffect(() => {
        setLocalValue(row[name] ?? '');
    }, [row[name]]);

    const isFalsyValue = row[name] === null || row[name] === undefined || row[name] === '';

    const handleChange = (e: any) => {
        const val = e.target.value.replace('$', '').replaceAll(',', '');
        setLocalValue(val);
        row[name] = val;

        setJurisdictionIdIndex(p);
        if (row["placeHolder"] === true) {
            setTaxYear?.(row["bill_year"]);
            setIsAddNewSummaryRow?.(true);
        }
        row["placeHolder"] = false;
        setIsSavedResult(false);
        setAutoCalculate(true);
        calculateAsOfDate(row);

        if (setUpdateTotalTaxValue !== null) {
            setUpdateTotalTaxValue(true);
        }
    };

    return (
        <NumberFormat
            placeholder={isFalsyValue ? "N/A" : "..."}
            className={row['placeHolder'] === false
                ? "border-0 form-control text-center"
                : "border-2 border-surface-8 form-control text-center"}
            decimalSeparator="."
            fixedDecimalScale
            min="0"
            prefix={!isFalsyValue ? "$" : ''}
            isNumericString={!!row[name]}
            value={isFalsyValue ? "N/A" : localValue}
            thousandSeparator={true}
            onChange={handleChange}
            disabled={row['jurisdictionName'] === '' || row['collectorName'] === '' || row['jurisdictionName'] === null || row['collectorName'] === null || !editable}
        />
    );
};
